<template>
  <aside class="menu-sidebar d-none d-lg-block">
    <router-link to="/" class="logo">
      <img src="@/assets/images/logo.jpg">
    </router-link>
    <div class="menu-sidebar__content js-scrollbar1">
      <nav class="navbar-sidebar">
        <ul class="list-unstyled navbar__list">
          <li>
            <router-link :to="{name: 'Statistics'}">
              <i class="fas fa-tachometer-alt"></i>Хянах самбар
            </router-link>
          </li>
          <li>
            <router-link :to="{name: 'SubmenuList'}">
              <i class="fas fa-list-ul"></i>Меню
            </router-link>
          </li>
          <li>
            <router-link :to="{name: 'Banner'}">
              <i class="far fa-window-restore"></i>Зарын баннер
            </router-link>
          </li>
          <li>
            <router-link :to="{name: 'Design'}">
              <i class="fas fa-pencil-alt"></i>Дизайн
            </router-link>
          </li>
          <li>
            <router-link :to="{name: 'UserList'}">
              <i class="fas fa-users"></i>Хэрэглэгчид
            </router-link>
          </li>
          <li>
            <router-link :to="{name: 'InquiryList'}">
              <i class="fas fa-comments"></i>Санал хүсэлтүүд
            </router-link>
          </li>
          <li>
            <router-link :to="{name: 'AdminList'}">
              <i class="fas fa-users-cog"></i>Админууд
            </router-link>
          </li>
          <li v-if="isSuperAdmin">
            <router-link :to="{name: 'EbarimtSend'}">
              <i class="fas fa-paper-plane"></i>И-баримт илгээх
            </router-link>
          </li>
        </ul>
      </nav>
    </div>
  </aside>
</template>

<script>
export default {
  computed: {
    isSuperAdmin: function() {
      return this.$store.getters.loggedAdmin.role == 0;
    }
  }
};
</script>